// @flow
import { useAppSelector } from 'src/hooks/useAppSelector';

import { selectBulkResponse } from '../modules/cart';

import { ResultList } from './ResultList';

import styles from './Content.scss';

export const BulkResult = (): React.MixedElement => {
  const results = useAppSelector(selectBulkResponse);

  return (
    <div className={styles.root}>
      <ResultList
        results={[...results.transfer_error, ...results.transferable]}
        title="Domains ready to transfer"
        kind="transferable"
      />
      <ResultList
        results={results.creatable}
        title="Domains create"
        kind="creatable"
      />
      <ResultList
        results={results.unavailable}
        title="Domains unavailable at the moment"
        kind="unavailable"
      />
    </div>
  );
};
